

import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors } from '@aston/foundation';
import { ISubsidiaryListItem } from 'apps/console/src/app/subsidiaries-module/models';
import { AccessLevel } from 'apps/console/src/app/shared-module/enums';

import { AppStoreSelectors } from '../app-store';

import { FeatureName } from './feature';
import { ISubsidiariesState } from './state';


export const selectState: MemoizedSelector<object, ISubsidiariesState> = createFeatureSelector<ISubsidiariesState>(FeatureName);

export const getHasLoadedOnce = (state: ISubsidiariesState): boolean => state.hasLoadedOnce;
export const selectHasLoadedOnce = createSelector(selectState, state => getHasLoadedOnce(state));
export const selectHasPendingSubsidiaries = createSelector(selectState, state => state.hasPendingItems);

export const {
	getEntity: getSubsidiaries,
	selectEntity: selectSubsidiaries,
	selectIsLoading: selectSubsidiariesIsLoading,
	selectError: selectSubsidiariesError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaries));

export const getSubsidiariesCount = (state: ISubsidiariesState): number => state.subsidiaries.entity.length;
export const selectSubsidiariesCount = createSelector(selectState, state => getSubsidiariesCount(state));

export const getHasSubsidiaries = (state: ISubsidiariesState): boolean => getSubsidiariesCount(state) > 0;
export const selectHasSubsidiaries = createSelector(selectState, state => getHasSubsidiaries(state));

export const getSubsidiaryById = (state: ISubsidiariesState, id: number): ISubsidiaryListItem => getSubsidiaries(state.subsidiaries).find(s => s.subsidiaryId === id);
export const selectSubsidiaryById = (id: number) => createSelector(selectState, state => getSubsidiaryById(state, id));

export const selectCanCreateFederation = createSelector(selectSubsidiaries, AppStoreSelectors.selectCurrentUserIsSupport,
	(subsidiaries, isSupport) => isSupport && subsidiaries?.length >= 2 && subsidiaries?.find(s => s.accessLevel === AccessLevel.Admin));

